module.exports = __webpack_public_path__ + "static/homepage-wireframe-final-0e4320054ac24b0aa31e4e4073e99dbd.png";